// Centralized testimonials data
// This file serves as the single source of truth for all testimonials across the website

export const testimonials = [
    {
        id: 1,
        quote: "ZovoX Technologies transformed our business operations with their AI automation solutions. The efficiency gains have been remarkable.",
        author: "Rajesh Kumar",
        role: "CEO",
        company: "TechVision Solutions",
        industry: "Technology",
        rating: 5,
        avatar: "https://ui-avatars.com/api/?name=Rajesh+Kumar&background=3b82f6&color=fff&size=128",
        logo: "https://ui-avatars.com/api/?name=TV&background=3b82f6&color=fff&size=64&bold=true",
        featured: true,
        approved: true,
        submittedAt: "2024-11-15T10:30:00Z",
        approvedAt: "2024-11-15T14:00:00Z"
    },
    {
        id: 2,
        quote: "Outstanding service and support. Their custom internal tools have streamlined our entire workflow.",
        author: "Priya Sharma",
        role: "Operations Manager",
        company: "RetailPro India",
        industry: "Retail",
        rating: 5,
        avatar: "https://ui-avatars.com/api/?name=Priya+Sharma&background=8b5cf6&color=fff&size=128",
        logo: "https://ui-avatars.com/api/?name=RP&background=8b5cf6&color=fff&size=64&bold=true",
        featured: true,
        approved: true,
        submittedAt: "2024-11-10T09:15:00Z",
        approvedAt: "2024-11-10T16:30:00Z"
    },
    {
        id: 3,
        quote: "The web application they built for us is fast, reliable, and exactly what we needed. Highly recommended!",
        author: "Amit Patel",
        role: "Founder",
        company: "HealthFirst Clinics",
        industry: "Healthcare",
        rating: 5,
        avatar: "https://ui-avatars.com/api/?name=Amit+Patel&background=10b981&color=fff&size=128",
        logo: "https://ui-avatars.com/api/?name=HF&background=10b981&color=fff&size=64&bold=true",
        featured: true,
        approved: true,
        submittedAt: "2024-11-05T11:45:00Z",
        approvedAt: "2024-11-05T15:20:00Z"
    },
    {
        id: 4,
        quote: "Professional team with deep technical expertise. They delivered our project on time and within budget.",
        author: "Sneha Reddy",
        role: "CTO",
        company: "LogiTrack Systems",
        industry: "Logistics",
        rating: 5,
        avatar: "https://ui-avatars.com/api/?name=Sneha+Reddy&background=f59e0b&color=fff&size=128",
        logo: "https://ui-avatars.com/api/?name=LT&background=f59e0b&color=fff&size=64&bold=true",
        featured: false,
        approved: true,
        submittedAt: "2024-10-28T13:20:00Z",
        approvedAt: "2024-10-28T17:45:00Z"
    },
    {
        id: 5,
        quote: "Their automation solutions saved us countless hours of manual work. ROI was evident within the first month.",
        author: "Vikram Singh",
        role: "Director",
        company: "ManufacturePro Ltd",
        industry: "Manufacturing",
        rating: 5,
        avatar: "https://ui-avatars.com/api/?name=Vikram+Singh&background=ef4444&color=fff&size=128",
        logo: "https://ui-avatars.com/api/?name=MP&background=ef4444&color=fff&size=64&bold=true",
        featured: false,
        approved: true,
        submittedAt: "2024-10-20T08:30:00Z",
        approvedAt: "2024-10-20T12:15:00Z"
    },
    {
        id: 6,
        quote: "Excellent communication throughout the project. The final product exceeded our expectations.",
        author: "Meera Joshi",
        role: "Principal",
        company: "Bright Future Academy",
        industry: "Education",
        rating: 5,
        avatar: "https://ui-avatars.com/api/?name=Meera+Joshi&background=6366f1&color=fff&size=128",
        logo: "https://ui-avatars.com/api/?name=BF&background=6366f1&color=fff&size=64&bold=true",
        featured: false,
        approved: true,
        submittedAt: "2024-10-15T14:00:00Z",
        approvedAt: "2024-10-15T18:30:00Z"
    }
];

// Helper functions
export const getApprovedTestimonials = () => {
    return testimonials.filter(t => t.approved);
};

export const getFeaturedTestimonials = () => {
    return testimonials.filter(t => t.approved && t.featured);
};

export const getTestimonialsByIndustry = (industry) => {
    return testimonials.filter(t => t.approved && t.industry === industry);
};

export const addTestimonial = (testimonialData) => {
    const newTestimonial = {
        id: testimonials.length + 1,
        ...testimonialData,
        approved: false, // New testimonials need approval
        submittedAt: new Date().toISOString(),
        approvedAt: null
    };

    // In a real application, this would be saved to a database
    // For now, we'll just log it
    console.log('New testimonial submitted:', newTestimonial);

    return newTestimonial;
};

export default testimonials;
